<template>
    <div class="dashboard">
        <h1>Report Dashboard</h1>
        <b-card footer-class="p-0">
            <b-card-group deck>
                <b-card no-body class="border-0">
                    <total-active-patients />
                </b-card>
                <b-card no-body class="border-0">
                    <total-active-clients />
                </b-card>
                <b-card no-body class="border-0">
                    <total-appointment />
                </b-card>
            </b-card-group>
            <template v-slot:footer>
                <b-tabs card class="list">
                    <tab-schedule active button-id="tab-schedule" />
                    <tab-patient button-id="tab-patient" />
                    <tab-client button-id="tab-client" />
                    <tab-communication button-id="tab-communication" />
                    <tab-contact button-id="tab-contact" />
                    <tab-inventory button-id="tab-inventory" />
                    <tab-billing button-id="tab-billing" />
                    <tab-staff button-id="tab-staff" />
                    <tab-wellness
                        v-if="isWellnessPlanEnabled()"
                        button-id="tab-wellness"
                    />
                    <tab-custom-report
                        v-if="hasCustomReport"
                        button-id="tab-custom-report"
                    />
                </b-tabs>
            </template>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot";
import totalActivePatients from "./module/patient/total_active_patients";
import totalActiveClients from "./module/client/total_active_clients";
import totalAppointment from "./module/client/total_appointments";

export default {
    components: {
        totalActivePatients,
        totalActiveClients,
        totalAppointment,
        tabSchedule: () => import("@/module/report/tabs/tab-schedule.vue"),
        tabPatient: () => import("@/module/report/tabs/tab-patient.vue"),
        tabClient: () => import("@/module/report/tabs/tab-client.vue"),
        tabCommunication: () =>
            import("@/module/report/tabs/tab-communication.vue"),
        tabContact: () => import("@/module/report/tabs/tab-contact.vue"),
        tabInventory: () => import("@/module/report/tabs/tab-inventory.vue"),
        tabBilling: () => import("@/module/report/tabs/tab-billing.vue"),
        tabStaff: () => import("@/module/report/tabs/tab-staff.vue"),
        tabWellness: () => import("@/module/report/tabs/tab-wellness.vue"),
        tabCustomReport: () => import("@/module/report/tabs/tab-custom-report.vue")
    },
    computed: {},
    created() {},
    mounted() {
        this.checkHasCustomReport();
    },
    data() {
        return {
            hasCustomReport: true
        };
    },
    methods: {
        isWellnessPlanEnabled() {
            let self = this;
            let status = false;
            _.forEach(self.$root._data.extensions, function (data) {
                if (
                    data.extension_code == "WELLNESS" &&
                    data.status == "ENABLED"
                ) {
                    status = true;
                }
            });
            return status;
        },
        checkHasCustomReport() {
            let self = this;
            let countPublishCustomReports = 0;

            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "report/count-publish-custom-reports"
                )
                .then(function (response) {
                    countPublishCustomReports = parseInt(
                        response.data.response.resources
                    );
                    if (countPublishCustomReports <= 0) {
                        self.hasCustomReport = false;
                    } else {
                        self.hasCustomReport = true;
                    }
                });
        }
    }
};
</script>
